import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { NotificationsService } from './notifications.service';
import { AuthService } from '../auth/auth.service';
import { GetNotificationsResponseDTO } from './notifications.dto';
import { Router } from '@angular/router';
import { Preferences } from '@capacitor/preferences';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.page.html',
  styleUrls: ['./notifications.page.scss'],
})
export class NotificationsPage implements OnInit {
  isLoading = true;
  notifications = [];
  notificationsSub: Subscription;
  HasMoreData = true;
  userId: number;
  lastOpened: string;
  userTimeZone: string;
  constructor(
    private notificationsService: NotificationsService,
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnDestroy() {
    if (this.notificationsSub) this.notificationsSub.unsubscribe();
  }

  async ngOnInit() {
    this.userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const { value } = await Preferences.get({ key: 'notificationOpened' });
    this.lastOpened = Date.now().toString();
    if (value) {
      this.lastOpened = value;
    }
    this.userId = await this.authService.getUserId();
    this.notificationsSub = this.notificationsService
      .getNotifications(this.userId, 0, this.lastOpened, this.userTimeZone)
      .subscribe((notifications: GetNotificationsResponseDTO[]) => {
        Preferences.set({
          key: 'notificationOpened',
          value: JSON.stringify(Date.now()),
        });
        this.notifications = notifications;
        if (this.notifications.length === 0) this.HasMoreData = false;
        else this.HasMoreData = true;
        this.isLoading = false;
      });
  }
  goToURL(url: string) {
    if (url && url.length > 0) {
      this.router.navigateByUrl(url);
    }
  }
  handleRefresh(event: any) {
    this.HasMoreData = true;
    this.notificationsSub = this.notificationsService
      .getNotifications(this.userId, 0, this.lastOpened, this.userTimeZone)
      .subscribe((notifications) => {
        this.notifications = notifications;
        if (this.notifications.length === 0) this.HasMoreData = false;
        else this.HasMoreData = true;
        this.isLoading = false;
        event.target.complete();
      });
  }

  async onIonInfinite(event: any) {
    const { value } = await Preferences.get({ key: 'notificationOpened' });
    this.lastOpened = Date.now().toString();
    if (value) {
      this.lastOpened = value;
    }
    this.notificationsSub = this.notificationsService
      .getNotifications(
        this.userId,
        this.notifications[this.notifications.length - 1].id,
        this.lastOpened,
        this.userTimeZone
      )
      .subscribe((notifications) => {
        Preferences.set({
          key: 'notificationOpened',
          value: JSON.stringify(Date.now()),
        });
        this.notifications = this.notifications.concat(notifications);
        const hasLastPost = this.notifications.find(
          (a) => a.isLastPost === true
        );
        if (hasLastPost === undefined) event.target.complete();
        else this.HasMoreData = false;
      });
  }
}
